import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { createGlobalStyle,ThemeProvider } from "styled-components";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Hind Siliguri", sans-serif;
  }
  *{
    box-sizing: border-box;
  }
`;

const theme = {
  colors: {
    default: "#D60E64",
    offWhite: "#5f6368",
    white: "#fff"
  },
  backgroundColors: {
    default: "#D60E64"
  },
  font:{
    weight:{
      default: 500,
      medium: 600,
      bold: 700
    }
  },
  border:{
    default: "#dadce0"
  },
  padding:{
    unMatch: "120px"
  }
}

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
